import React from 'react'
import MediaMenuItem from '../MediaMenu/MediaMenuItem'
import Props from './types'
import { IconType } from '@bt-react/components/Icon'

const SpotlightButton: React.FC<Props> = props =>
  <MediaMenuItem
    onClick={props.mediaDrawerOpen ? props.closeMediaDrawer : props.openMediaDrawer}
    dataBdd={props.isActive ? 'talks-spotlight-button-active' : 'talks-spotlight-button'}
    active={props.isActive}
    icon={IconType.iconName.thLarge}
    text={`Presenters`}
    disabled={false}
    notifications={props.presenterCount}
    mediaType='SPOTLIGHT'
  />

export default SpotlightButton
